import { translate } from '~l10n/client';

import { toast } from '~shared/components/Toast';
import { ReportUrls } from '~shared/utils/urlBuilders/ReportsUrlBuilder';

import { pollForDownloadReady } from '../../../util/ReportDownload';
import axios from '../../localAxios';

function downloadQuizApi(body, shouldAutoPoll = true) {
  const url = new ReportUrls().downloadEmptyQuizUrl();
  return axios
    .post(url, body)
    .then((response) => {
      const data = response['data'];
      
      if (shouldAutoPoll) {
        toast(translate('Your download will begin shortly'), {
          duration: 2500,
        });
        pollForDownloadReady({
          pollingUrl: data['url'],
        });
      } else {
        // Return data for caller to handle polling
        return data;
      }
    })
    .catch((error) => {
      console.error(error);
      toast(translate('An unknown error occurred. Please try again later.'), {
        tone: 'critical',
      });
      throw error;
    });
}

export function downloadEmptyWorkspaceQuiz(
  quizId: string,
  workspaceId: string
) {
  return downloadQuizApi({
    workspace_data: { workspace_id: workspaceId, workspace_quiz_id: quizId },
  });
}

export async function downloadEmptyQuiz(quizId: number) {
  return downloadQuizApi({ quiz_id: quizId });
}

export async function downloadAnswerKey(
  quizId: number,
  options?: any
) {
  return downloadQuizApi(
    {
      quiz_id: quizId,
      options: options || { include_explanations: false, include_correct_answers: true },
    },
    false // Don't auto-poll, return data for caller to handle
  );
}

export function downloadWorkspaceAnswerKey(
  quizId: string,
  workspaceId: string,
  options?: any
) {
  return downloadQuizApi(
    {
      workspace_data: { workspace_id: workspaceId, workspace_quiz_id: quizId },
      options: options || { include_explanations: false, include_correct_answers: true },
    },
    false // Don't auto-poll, return data for caller to handle
  );
}
